// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ThunderboltOutlinedSvg from "@ant-design/icons-svg/es/asn/ThunderboltOutlined";
import AntdIcon from '../components/AntdIcon';

var ThunderboltOutlined = function ThunderboltOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltOutlinedSvg
  }));
};

ThunderboltOutlined.displayName = 'ThunderboltOutlined';
export default React.forwardRef(ThunderboltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ThunderboltOutlined.js
// module id = 1935
// module chunks = 0